import {Component} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import "rxjs/add/operator/toPromise";
import {Observable} from "rxjs";

@Component({
  templateUrl: "./ca-acknowledgment-dialog.template.pug",
})
export class CAAcknowledgmentDialogComponent extends DialogComponent<any, any> {
  acknowledge() {
    this.result = true;
    this.close();
  }

  cancel() {
    this.result = false;
    this.close();
  }

  static showDialogModal(dialogService: DialogService): Observable<any> {
    return dialogService.addDialog(
      CAAcknowledgmentDialogComponent,
      {backdropColor: "rgba(0, 0, 0, 0.5)"},
    );
  }

  constructor(public dialogService: DialogService) {
    super(dialogService);
  }
}
